import { Context } from '@nuxt/types'

export default function({ route, redirect }: Context) {
  // Old parameters to remove. The were needed for Car1.
  const paramsToRemove = ['context', 'lang', 'quick-search', 'root', 'vtype']

  const currentQuery = { ...route.query }
  let hasParamsToRemove = false

  // Check if we have parameters to remove
  paramsToRemove.forEach(param => {
    if (param in currentQuery) {
      delete currentQuery[param]
      hasParamsToRemove = true
    }
  })

  // Only redirect if we have parameters to remove
  if (hasParamsToRemove) {
    // Use redirect which is similar to router.replace
    return redirect({
      path: route.path,
      query: currentQuery
    })
  }
}
